<template>
  <div>
    <fieldset>
      <legend class="body-s-high">
        <InputLabel
          :info="info"
          :label="legend"
          :required="required"
        />
      </legend>
      <div class="options">
        <label
          v-for="{ label, value: valueOption } in options"
          :key="label"
          class="body-s-regular"
        >
          <input
            :checked="value === valueOption"
            :disabled="disabled"
            type="radio"
            :value="valueOption"
            @input="$emit('update:value', $event.target.value)"
          >
          {{ label }}
        </label>
      </div>
    </fieldset>
    <slot name="errors" />
  </div>
</template>

<script>
import InputLabel from './InputLabel.vue'

export default {
  name: 'RadioInput',
  components: {
    InputLabel,
  },
  props: {
    legend: {
      type: String,
      required: true,
    },
    options: {
      type: Array,
      required: true,
      validator: (options) => {
        return options.every(option => 'label' in option && 'value' in option)
      },
    },
    value: {
      type: String,
      default: '',
    },
    info: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:value'],
}
</script>

<style scoped>
fieldset {
  border: none;
  padding: 0;
}
legend, label {
  margin: 0;
  display: flex;
  align-items: center;
  gap: var(--space-1);
}
legend {
  display: block;
}
.options {
  display: flex;
  gap: var(--space-3);
  margin-top: var(--space-1);
}
</style>
